module.exports = __webpack_public_path__ + "static/media/RESUME.7abf8b85.pdf";